import nestAxios from './_nestAxios'

export const get = _id => nestAxios.get(`/activos-fijos/${_id}`)
export const getSelect = ({ cuenta }) =>
  nestAxios.get('/activos-fijos', {
    params: {
      tipoConsulta: 'select',
      cuenta: cuenta
    }
  })

export const getLibroActivosxId = idActivo =>
  nestAxios.get('/activos-fijos/libro-activos', {
    params: { idActivo: idActivo }
  })

export const nuevoCodigo = () => nestAxios.get('/activos-fijos/nuevo-codigo')

export const descargarPlantilla = () =>
  nestAxios.get('/activos-fijos/descargar/plantilla', {
    responseType: 'blob'
  })

export const descargarReporteActivos = params => nestAxios.get('/activos-fijos/descargar/reporte-activos', { responseType: 'blob', params: params })

export const actualizar = (_id, data) => nestAxios.put(`/activos-fijos/${_id}`, data)

export const nuevo = data => nestAxios.post('/activos-fijos', data)

export const nuevoActivoModal = data => nestAxios.post('/activos-fijos/nuevo-modal', data)

export const importarActivosFijos = data => nestAxios.post('/activos-fijos/importar', data)

export const eliminar = _id => nestAxios.delete(`/activos-fijos/${_id}`)
